<template>
  <f7-page class="accountDetail_page" @page:init="updateAccount()">
    <f7-navbar sliding no-shadow back-link>
      <f7-nav-title v-if="activeAccount">{{ activeAccount.tag }}</f7-nav-title>
      <f7-nav-right>
        <f7-link v-if="activeAccount && activeAccount.kyc_level !== 'LEVEL_0'" icon-color="primary"
          icon-ios="f7:text_badge_plus" icon-md="material:playlist_add" color="primary"
          @click="openPopuNewWallet()"></f7-link>
        <navbarright></navbarright>
      </f7-nav-right>
    </f7-navbar>
    <div class="layout_content" style="padding-bottom: 100px !important">
      <div class="left_layout"></div>
      <div class="main_layout">
        <!-- <templatePreloader v-if="!activeAccount"></templatePreloader> -->

        <f7-card outline header-divider class="border-color-blue highlighted">
          <f7-card-header class="grid grid-rows-2" v-if="activeAccount"><span>{{ activeAccount.tag }}</span>
            <span style="font-size: small" v-if="activeAccount.type !== ''">{{
              getAccountType(activeAccount.type) }} №:
              {{ activeAccount.id }}</span></f7-card-header>

          <f7-card-content v-if="activeAccount">
            <h4>
              {{ $t("common.status") }}:
              <f7-badge :color="activeAccount.status === 'ACTIVE' ? 'primary' : 'deeporange'">
                {{ getAccountStatus(activeAccount.status) }}</f7-badge>
            </h4>

            <f7-list strong inset media-list v-if="mainWallet">
              <f7-list-item>{{ $t("common.accountMainWallet") }}</f7-list-item>
              <li>
                <div class="item-content">
                  <div class="item-inner">
                    <div class="item-title-row">
                      <div class="item-title">{{ mainWallet.tag }}</div>

                      <div class="item-after">№: {{ mainWallet.id }}</div>
                    </div>
                    <div class="item-title-row">
                      <div class="item-title">{{ $t("common.balance") }}</div>

                      <div class="item-after">
                        {{
                          $filtersToCurrency.toCurrency(
                            mainWallet.balance,
                            null,
                            mainWallet.currency
                          )
                        }}
                      </div>
                    </div>
                    <div class="item-title-row">
                      <div class="item-title">{{ $t("common.availaible_balance") }}</div>

                      <div class="item-after">
                        {{
                          $filtersToCurrency.toCurrency(
                            mainWallet.balance,
                            null,
                            mainWallet.currency
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <f7-list-item v-if="accountWallets && accountWallets.length > 0"
                @smartselect:closed="setAccountMainWallet()" :title="$t('common.assignOrChangeMainWallet')" smart-select
                :smart-select-params="{
                  openIn: isTablet ? 'page' : 'popup',
                  closeOnSelect: true,
                }">
                <select name="main_wallet" v-model="currentMainWallet">
                  <optgroup :label="activeAccount.tag">
                    <option v-for="wallet in accountWallets" :value="wallet.id"
                      :selected="wallet.id == mainWallet.id"
                      :data-option-color="wallet.id == mainWallet.id ? 'primary' : ''">
                      {{ wallet.tag }} №:{{ wallet.id }}
                    </option>
                  </optgroup>
                </select>
              </f7-list-item>
            </f7-list>
          </f7-card-content>
          <!-- <f7-card-content>
            <kyclevel v-if="activeAccount" :activeAccount="activeAccount"></kyclevel>
          </f7-card-content> -->
        </f7-card>

        <f7-block-title large v-if="accountWallets && accountWallets.length > 0">
          {{ $t("common.accountwallets") }}</f7-block-title>
        <div class="grid xsmall-grid-cols-1 small-grid-cols-2">
          <a v-for="(wallet, index) in accountWallets" :key="index"
            :href="`/account/${activeAccount.id}/wallet/${wallet.id}`">
            <f7-card grid outline header-divider style="height: 250px" :class="wallet.main
                ? 'border-color-primary highlighted'
                : wallet.shared
                  ? 'border-color-orange highlighted'
                  : 'border-color-teal highlighted'
              ">
              <f7-link :id="`wallet_${wallet.id}`" @click="openWalletMenu(wallet)" icon-color="primary"
                icon-ios="f7:menu" icon-md="material:menu" style="position: absolute; right: 4px; top: 4px"></f7-link>
              <f7-card-header class="grid grid-rows-2" style="height: 100px">
                <span style="font-size: large">{{ wallet.tag }}</span><span style="font-size: small">№: {{ wallet.id
                  }}</span>
              </f7-card-header>
              <f7-card-content class="grid grid-rows-2">
                <span>
                  {{ $t("common.balance")
                  }}<span style="font-size: x-large; font-weight: 500">{{
                    $filtersToCurrency.toCurrency(wallet.balance, null, wallet.currency)
                    }}</span></span>
                <span>
                  {{ $t("common.availaible_balance") }}
                  <span style="font-size: large; font-weight: 300">{{
                    $filtersToCurrency.toCurrency(
                      wallet.balance_available,
                      null,
                      wallet.currency
                    )
                  }}</span></span>
              </f7-card-content>
            </f7-card>
          </a>
        </div>
      </div>
      <div class="right_layout"></div>
    </div>
    <!-- && activeAccount.kyc_level !== 'LEVEL_0' -->
    <f7-fab v-if="activeAccount" position="center-bottom" :text="$t('account.addNewApiWallet')" color="primary"
      href="#" @click="openPopuNewWallet()">
      <f7-icon ios="f7:plus" aurora="f7:plus" md="material:add"></f7-icon>
    </f7-fab>
    <AdaptiveSheet class="addNewApiWallet" style="--f7-sheet-bg-color: #fff" swipe-to-close :tablet-fullscreen="true" @open=" getAllowedCountryList()"
      backdrop close-by-backdrop-click close-on-escape full-screen><f7-view>
        <f7-page>
          <f7-navbar>
            <div class="left"></div>
            <div class="title">
              {{ $t("account.addNewApiWallet") }}
            </div>
            <div class="right">
              <f7-link sheet-close popup-close icon-f7="multiply"></f7-link>
            </div>
          </f7-navbar>
          <div class="layout_content">
            <div class="left_layout"></div>
            <div class="main_layout">
              <f7-block-title large>
                {{ $t("account.addNewApiWalletToAccount") }}</f7-block-title>
              <f7-block>
                <f7-list dividers-ios strong-ios media-list>
                  <f7-list-item v-if="activeAccount" :title="activeAccount.type"
                    :after="'№:' + activeAccount.id" />

                  <f7-list-item :header="$t('common.selectCountry')" class="selectCountry" smart-select
                    :smart-select-params="{
                      openIn: !isTablet || isNativePlatform ? 'popup' : 'page',
                      searchbar: true,
                      searchbarPlaceholder: $t('common.findCountry'),
                      closeOnSelect: true,
                    }" >
                    <template #subtitle v-if="userCtry && walletctry">
                      <img :src="'https://flagcdn.com/' + userCtry.toLowerCase() + '.svg'
                        " width="24" />
                      {{ walletctry.countryName }} - {{ walletctry.currencyCode }}
                      {{ walletctry.currencyName }}
                    </template>
                    <select name="walletCountry" v-model="userCtry" required validate>
                      <optgroup class="list-group" v-for="(countryList, continentName, index) in allowedCountries"
                        :label="continentName" :key="index">
                        <option v-for="country in countryList" :key="country.id" :value="country.countryCode2"
                          :selected="country.countryCode2 === userCtry" :data-option-image="country.countryCode2 !== ''
                              ? 'https://flagcdn.com/' +
                              country.countryCode2.toLowerCase() +
                              '.svg'
                              : ''
                            " width="24">
                          {{ country.countryName }} - {{ country.currencyCode }}
                          {{ country.currencyName }}
                        </option>
                      </optgroup>
                    </select>
                  </f7-list-item>

                  <f7-list-input :label="$t('common.tag')" floating-label :info="$t('common.tagInfo')"
                    :error-message="$t('common.tagInfo')" v-model:value="tag" name="tag"
                     resizable required validate maxlength="80" type="text" />
                </f7-list>

                <f7-button round-ios fill large rippled class="buttons" color="primary" strong @click="addApiWallet()">{{
                  $t("account.addNewApiWallet") }}</f7-button>
              </f7-block>
            </div>
            <div class="right_layout"></div>
          </div>
        </f7-page>
      </f7-view>
    </AdaptiveSheet>
  </f7-page>
</template>
<style scoped></style>
<script setup>
import { ref, computed, onMounted } from "vue";
import { theme, f7 } from "framework7-vue";
import navbarright from "../components/navbarright.vue";
import { useAccount } from "@/js/composables/useAccount.js";
import { useApimoneyStore } from "../js/pinia-stores/apimoney.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import {
  useTabletScreen,
  useDesktopScreen,
} from "../js/composables/useMediaQuery.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useLocationStore } from "../js/pinia-stores/location.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import { openAdaptiveModal } from "../js/composables/useAdaptiveModal.js";
import AdaptiveSheet from "../components/common/AdaptiveSheet.vue";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const { f7route, f7router } = props;

const {
  userAccount, profile, isNativePlatform,
  mainWallet, accountWallets, countries,
  getAccountType, getAccountStatus, setAccountMainWallet,
  openWalletMenu, addApiWallet,
  tag, userCtry, currentMainWallet, walletctry,
  allowedCountries, allowedCountryList,
} = useAccount({ f7route, f7router });
const isTablet = useTabletScreen().matches;
const isDeskTop = useDesktopScreen();
const documentsUrl = computed(() => useAuthStore().documentsUrl);
const document = computed(() => useAuthStore().document);
const destinationCity = computed(() => useLocationStore().destinationCity);
const country = computed(() => useLocationStore().country);

const activeAccount = computed(() => {
  if (userAccount.value && f7route.params.type !== ``) {
    return f7route.params.type === "standard"
      ? userAccount.value.standard
      : userAccount.value.business;
  }
  return null;
});

onMounted(() => {
  userCtry.value = userAccount.value?.countryCode || profile.value?.countryCode;
  if (mainWallet.value) {
    currentMainWallet.value = mainWallet.value.id;
  }
});

function updateAccount() {
  if (!userAccount.value && useKeycloakStore().authenticated) {
    useAccountStore().loadAccount(profile.value.sub);
  }
}

function openPopuNewWallet() {
  openAdaptiveModal(".addNewApiWallet");
}

function getAllowedCountryList() {
  if (!allowedCountries.value || allowedCountries.value.length == 0) {
    useApimoneyStore().getAllowedCountries();
  }
}
</script>
